import {Button, Modal} from 'react-bootstrap'
import {ActivityTab} from '../../onePolicy/components/ActivityTab'
import {parseId} from '../../../helpers'

interface IModalProps {
  id: string
  isOpen: boolean
  onClose: () => void
}
export const ModalViewLogs: React.FC<IModalProps> = ({isOpen, onClose, id}) => {
  return (
    <Modal show={isOpen} onHide={onClose} size='xl'>
      {/* <Modal.Header closeButton>
        <Modal.Title>Cancel policy</Modal.Title>
      </Modal.Header> */}
      <Modal.Body>
        <ActivityTab id={'' + parseId(id)} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' size='sm' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
